import { AdministrationIcon, BookingsIcon, CustomerHappinessIcon, DashboardIcon, MaintenanceReqestIcon, MeetingsIcon, TransportationIcon, TransportationSideNavIcon } from '../Icons';

export const MainMenu = [
    {
        title: 'main_dashboard',
        permission: 'main_dashboard',
        path: '/main_dashboard',
        icon: <DashboardIcon className='sidenav-icon' />,
        subNav: []
    },
    {
        title: 'main_dashboard',
        permission: 'enduser_dashboard',
        path: '/enduser_dashboard',
        icon: <DashboardIcon className='sidenav-icon' />,
        subNav: []
    },
    {
        title: 'meetings',
        permission: 'meetings',
        requiredService: 'MEETINGS',
        path: "/meetings",
        icon: <MeetingsIcon className='sidenav-icon' />,
        subNav: [
            {
                title: "hall_booking",
                permission: "hall_booking",
                path: "/meetings/hall_booking",
                cName: "sub-nav",
            },
            {
                title: "meetings_hospitality",
                permission: "meetings_hospitality",
                path: "/meetings/meetings_hospitality",
                cName: "sub-nav",
            },
            {
                title: "manage_halls",
                permission: "manage_halls",
                path: "/meetings/manage_halls",
                cName: "sub-nav",
            },
            {
                title: "hall_booking",
                permission: "enduser-meetings",
                path: "/meetings/hall_booking",
                cName: "sub-nav",
            }
        ]
    },
    {
        title: 'bookings',
        permission: 'bookings',
        path: '/bookings',
        icon: <BookingsIcon className='sidenav-icon' />,
        subNav: [
            {
                title: 'hotels',
                permission: 'hotels',
                requiredService: 'HOTEL_BOOKINGS',
                path: '/bookings/hotels',
                cName: 'sub-nav'
            },
            {
                title: 'hotel_booking',
                permission: 'hotel_booking',
                requiredService: 'HOTEL_BOOKINGS',
                path: '/bookings/hotel_booking',
                cName: 'sub-nav'
            },
            {
                title: 'ticket_booking',
                permission: 'ticket_booking',
                path: '/bookings/ticket_booking',
                cName: 'sub-nav'
            },
            {
                title: 'myhotelbookings',
                permission: 'myhotelbookings',
                path: '/bookings/hotel_booking',
            },
            {
                title: 'myticketbookings',
                permission: 'myticketbookings',
                path: '/bookings/ticket_booking',
            },
            {
                title: 'myhotelreplies',
                permission: 'myhotelreplies',
                path: '/bookings/hotel_replies',
            },
            {
                title: 'myticketreplies',
                permission: 'myticketreplies',
                path: '/bookings/ticket_replies',
            },
            {
                title: 'suppliers',
                permission: 'suppliers',
                path: '/bookings/suppliers',
                cName: 'sub-nav'
            },
            {
                title: 'hotel_booking',
                permission: 'enduser-hotelbookings',
                path: '/bookings/hotel_booking',
                cName: 'sub-nav'
            },
            {
                title: 'ticket_booking',
                permission: 'enduser-ticketbookings',
                path: '/bookings/ticket_booking',
                cName: 'sub-nav'
            },
        ]
    },
    {
        title: 'transportation',
        permission: 'transportation',
        path: '/transportation',
        icon: <TransportationSideNavIcon className='sidenav-icon' />,
        subNav: [
            {
                title: 'vehicles',
                permission: 'vehicles',
                path: '/transportation/vehicles',
                cName: 'sub-nav'
            },
            {
                title: 'drivers',
                permission: 'drivers',
                path: '/transportation/drivers',
                cName: 'sub-nav'
            },
            {
                title: 'violations',
                permission: 'violations',
                path: '/transportation/violations',
                cName: 'sub-nav'
            },
            {
                title: 'transportation_tasks',
                permission: 'transportation_tasks',
                path: '/transportation/transportation_tasks',
                cName: 'sub-nav'
            },
            {
                title: 'mytasks',
                permission: 'mytasks',
                path: '/transportation/transportation_tasks',
            },
            {
                title: 'maintenance_checks',
                permission: 'maintenance_checks',
                path: '/transportation/maintenance_checks',
                cName: 'sub-nav'
            },
            {
                title: 'licence_checks',
                permission: 'licence_checks',
                path: '/transportation/licence_checks',
                cName: 'sub-nav'
            },
            {
                title: 'transportation_tasks',
                permission: 'enduser-tasks',
                path: '/transportation/transportation_tasks',
                cName: 'sub-nav'
            },
        ]
    },


    {
        title: 'maintenance_request',
        permission: 'enduser_maintenance_request',
        path: '/maintenance_requests',
        icon: <MaintenanceReqestIcon className='sidenav-icon' />,
    },
    {
        title: 'maintenance_request',
        permission: 'maintenance_request',
        path: '/maintenance_requests',
        icon: <MaintenanceReqestIcon className='sidenav-icon' />,
    },
    {
        title: 'customer_happiness_service',
        permission: 'customer_happieness',
        icon: <CustomerHappinessIcon className='sidenav-icon' />,
        subNav: [
            {
                title: "general_feedbacks",
                permission: "feedbacks",
                path: "/customer_happiness/feedback",
                cName: "sub-nav",
            },
            {
                title: "home_assessment",
                permission: "homeassessments",
                path: "/customer_happiness/home_assessment",
                cName: "sub-nav",
            },
            {
                title: "general_feedbacks",
                permission: "enduser_feedbacks",
                path: "/customer_happiness/feedback",
                cName: "sub-nav",
            },
            {
                title: "home_assessment",
                permission: "enduser_homeassessments",
                path: "/customer_happiness/home_assessment",
                cName: "sub-nav",
            },
        ]
    },
    {
        title: "administration",
        permission: "administration",
        path: "/administration",
        icon: <AdministrationIcon className='sidenav-icon' />,
        subNav: [
            {
                title: "users",
                permission: "users",
                path: "/administration/users",
                cName: "sub-nav",
            },
            {
                title: "roles",
                permission: "roles",
                path: "/administration/roles",
                cName: "sub-nav",
            },
            // {
            //     title: "permissions",
            //     permission: "permissions",
            //     path: "/administration/permissions",
            //     cName: "sub-nav",
            // },
            // {
            //     title: "options",
            //     permission: "options",
            //     path: "/administration/options",
            //     cName: "sub-nav",
            // },
            // {
            //     title: "log",
            //     permission: "log",
            //     path: "/administration/log",
            //     cName: "sub-nav"
            // },
            // {
            //     title: "terms-and-conditions",
            //     permission: "terms-and-conditions",
            //     path: "/administration/terms-and-conditions",
            //     cName: "sub-nav"
            // }
        ],
    },
    {
        title: 'devices',
        permission: 'devices',
        path: '/devices',
        icon: <CustomerHappinessIcon className='sidenav-icon' />,
    },
    {
        title: "hr management",
        permission: "hr_management",
        path: "/hr-management",
        icon: <AdministrationIcon className='sidenav-icon' />,
        subNav: [
            {
                title: "vacations",
                permission: "vacations",
                path: "/hr-management/vacations",
                cName: "sub-nav",
            }
        ],
    },
    {
        title: "subscriptions",
        permission: "subscriptions",
        path: "/subscriptions",
        icon: <AdministrationIcon className='sidenav-icon' />,
    },
];

const toolbarStyle = {
    backgroundColor: 'var(--table-background)',
    // padding: '4px 12px',
    borderBottom: '1px solid var(--table-border)',
    marginBottom: '12px',
    '& .MuiButton-root': {
        position: 'relative',
        fontSize: 'var(--x-small)',
        fontWeight: 700,
        color: 'transparent',
        background: 'linear-gradient(var(--table-filter-color-1), var(--table-filter-color-2))',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        MozBackgroundClip: 'text',
        msBackgroundClip: 'text',
        OBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        MozTextFillColor: 'transparent',
        msTextFillColor: 'transparent',
        OTextFillColor: 'transparent',
        '&:hover::after': {
            content: '""',
            position: 'absolute',
            height: '100%',
            width: '100%',
            bottom: '0',
            left: '0',
            backgroundColor: 'var(--cell-hover)',
        }
    },
    '& svg path': {
        fill: 'url(#datagridToolbarGradient)'
    },
    '& .MuiBadge-badge': {
        backgroundColor: 'var(--table-filter-color-1)',
        width: '12px',
        minWidth: '12px',
        height: '12px',
    }
};

const paginationStyle = (theme = 'light-theme') => ({
    backgroundColor: theme === 'light-theme' ? '#DFE4E9' : '#305A87',
    color: theme === 'light-theme' ? '#374151' : '#D3D3D3',
    '& .MuiButtonBase-root:hover': {
        backgroundColor: 'rgba(0, 0, 0, .2)'
    }
});

const filterStyle = (theme = 'light-theme') => ({
    backgroundColor: theme === 'light-theme' ? '#DFE4E9' : '#204A77',
    '& .MuiSvgIcon-root path': {
        fill: theme === 'light-theme' ? '#374151' : '#D3D3D3',
    },
    '& .MuiFormLabel-root': {
        color: theme === 'light-theme' ? '#374151' : '#D3D3D3',
    },
    '& .MuiInputBase-input': {
        color: theme === 'light-theme' ? '#374151' : '#D3D3D3',
    },
    '& .MuiInputBase-root::before': {
        borderBottom: `1px solid ${theme === 'light-theme' ? '#374151' : '#D3D3D3'}`,
    },
    '& .MuiInputBase-root:hover::before': {
        borderBottom: `1px solid ${theme === 'light-theme' ? '#539EE9' : '#3F77B0'}`,
    },
    '& .MuiInputBase-root::after': {
        borderBottom: `2px solid ${theme === 'light-theme' ? '#539EE9' : '#3F77B0'}`,
    },
});

export const dataGridSlotProps = (theme = 'light-theme', fileName = 'table-data') => (
    {
        filterPanel: {
            sx: filterStyle(theme)
        },
        toolbar: {
            csvOptions: { utf8WithBom: true, fileName },
            printOptions: { disableToolbarButton: true },
            sx: toolbarStyle
        },
        pagination: {
            SelectProps: {
                MenuProps: {
                    PaperProps: {
                        sx: paginationStyle(theme)
                    }
                }
            },
            select: {
                menu: {
                    sx: paginationStyle(theme)
                }
            }
        }
    }
);

export const tableStyle = {
    padding: '0.625rem 1.375rem',

    border: 'none',
    backgroundColor: 'var(--table-background)',
    '--DataGrid-rowBorderColor': 'var(--cell-border)',
    '& .MuiDataGrid-main': {
        // padding: '0 12px',
        borderRadius: '8px'
    },
    '& .MuiDataGrid-scrollbar': {
        // right: '12px',
        '--size': '10px',
        '&::-webkit-scrollbar': {
            width: 10,
            height: 10,
        },
        '&::-webkit-scrollbar-track': {
            background: 'var(--cell-background)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'var(--cell-border)',
            transition: 'opacity .3s ease-out',
            borderRadius: 8,
            cursor: 'pointer',
            width: 8,
        },
        '&::-webkit-scrollbar-thumb:hover': {
            opacity: .8
        },
    },
    '& .MuiDataGrid-scrollbar--horizontal': {
        // width: 'calc(100% - 24px)'
    },
    '& .MuiDataGrid-columnHeader': {
        color: 'var(--header-color)',
        backgroundColor: 'var(--header-background)',
        fontSize: 'var(--x-small)',
    },
    '& .MuiDataGrid-columnHeaderTitle ': {
        fontWeight: 'bold',
        display: 'flex',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
        display: 'flex',
        justifyContent: 'space-between',

    },
    '& .MuiDataGrid-columnHeader:hover': {
        backgroundColor: 'var(--header-hover)'
    },
    '& .MuiDataGrid-columnHeader:focus': {
        borderColor: 'var(--cell-border)'
    },
    '& .MuiDataGrid-filler': {
        color: 'var(--header-color)',
        backgroundColor: 'var(--header-background)'
    },
    '& .MuiDataGrid-filler:hover': {
        backgroundColor: 'var(--header-hover)'
    },
    '& .MuiDataGrid-scrollbarFiller': {
        color: 'var(--header-color)',
        backgroundColor: 'var(--header-background)'
    },
    '& .MuiDataGrid-scrollbarFiller:hover': {
        backgroundColor: 'var(--header-hover)'
    },
    '& .MuiDataGrid-row': {
        color: 'var(--cell-color)',
        backgroundColor: 'transparent',
        fontSize: 'var(--small)',
        cursor: 'pointer'
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: 'var(--cell-hover)'
    },
    '& .MuiDataGrid-withBorderColor': {
        borderColor: 'var(--table-border)'
    },
    '& .css-1tdeh38': {
        backgroundColor: 'var(--cell-background)'
    },
    '& .MuiDataGrid-columnSeparator:hover': {
        backgroundColor: 'var(--header-hover)',
        color: 'var(--accent)'
    },
    '& .MuiSvgIcon-fontSizeSmall': {
        color: 'var(--header-color)'
    },
    '& .MuiSvgIcon-fontSizeSmall:hover': {
        color: 'var(--accent)'
    },
    '& .MuiSvgIcon-fontSizeInherit': {
        color: 'var(--header-color)'
    },
    '& .MuiSvgIcon-fontSizeInherit:hover': {
        color: 'var(--accent)'
    },
    '& .MuiDataGrid-selectedRowCount': {
        color: 'var(--part-color)'
    },
    '& .MuiButtonBase-root': {
        color: 'var(--accent)'
    },
    '& .Mui-disabled': {
        color: 'var(--cell-border)'
    },
    '& .MuiSelect-select': {
        backgroundColor: 'var(--button-background)',
        color: 'white',
        // border: '1px solid var(--button-border)',
        // boxShadow: 'inset 0 0 4px var(--button-shadow)',
        borderRadius: '0.5rem',
        height: '2.25rem',
        width: '3.563rem',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        fontSize: 'var(--small)',
        fontWeight: 'bold'
    },
    '& .MuiTablePagination-selectLabel': {
        fontSize: 'var(--medium)',
    },
    '& .MuiToolbar-root': {
        color: 'var(--part-color)'
    },
    '& .MuiSelect-icon': {
        color: 'white'
    },
    '& .css-i4bv87-MuiSvgIcon-root': {
        fill: 'var(--accent)'
    },
    '& .MuiDataGrid-columnSeparator': {
        // display: 'none'
    },
    ' & .MuiDataGrid-menuIcon': {
        display: 'none'
    },
    '& .MuiDataGrid-iconButtonContainer': {
        visibility: 'visible',
        width: 'auto',
    },

    '& .MuiDataGrid-sortIcon': {
    },

    '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
        opacity: '0.3 !important',
        visibility: 'visible',
    },
    '& .MuiDataGrid-root, & .MuiDataGrid-row--borderBottom, & .MuiDataGrid-columnHeader': {
        borderBottom: 'none !important'
    },
    '& .MuiDataGrid-columnHeaders': {
        borderRadius: '0.875rem',
        overflow: 'hidden'
    },
    '& .MuiDataGrid-root, .MuiDataGrid-withBorderColor': {
        border: 'none'
    },
    '& .MuiDataGrid-footerContainer': {
        // position: 'fixed',
        // bottom: 0,
        // width: 'calc(100vw - 23rem)',
        // width: '100%',
        // right: lang === 'en' ? '0.8rem' : 'auto',
        // left: lang === 'en' ? 'auto' : '0.8rem',
    }
};

export const dateTimeProps = (theme = 'light-theme', lang = 'en', small = false, height, border) => ({
    textField: {
        sx: {
            width: '100%',
            '& .MuiInputBase-root': {
                height
            },

            // border: border ? border : '1px solid var(--input-border)',

            '& .MuiSvgIcon-root': { fontSize: '1rem' }
        }
    },
    openPickerButton: {
        sx: {
            width: 'auto',
        }
    },
    openPickerIcon: {
        sx: {
            color: 'var(--root-color)',
            ':hover': {
                color: 'var(--input-border)'
            }
        }
    },
    popper: {
        sx: {
            '& .MuiList-root': {
                scrollbarWidth: 'thin'
            },
            '& .MuiPaper-root': {
                backgroundColor: theme === 'light-theme' ? '#EBEDF1' : '#16324F',
                color: theme === 'light-theme' ? '#374151' : '#DDEAF7'
            },
            '& .MuiTypography-root': {
                color: 'rgb(118, 121, 128)'
            },
            '& .MuiButtonBase-root': {
                color: theme === 'light-theme' ? '#111827' : '#BEDBFF'
            },
            '& .MuiPickersDay-root.Mui-disabled:not(.Mui-selected)': {
                color: 'rgb(118, 121, 128)'
            },
            '& .MuiButtonBase-root.Mui-selected': {
                backgroundColor: theme === 'light-theme' ? '#11182744' : '#BEDBFF',
                color: theme === 'light-theme' ? '#539EE9' : '#3F77B0',
                transition: 'opacity .3s ease'
            },
            '& .MuiButtonBase-root.Mui-selected:hover': {
                backgroundColor: theme === 'light-theme' ? '#829AB1' : '#BEDBFF',
                color: theme === 'light-theme' ? '#539EE9' : '#3F77B0',
                opacity: .85
            }
        }
    }
});